import _ from 'lodash';
import { useState } from 'react';

import useInterval from 'hooks/useInterval';

const useCookieChange = (field?: string, options = { toJson: true }) => {
    const [cookie, setCookie] = useState(document.cookie);
    useInterval(() => {
        if (document.cookie !== cookie) {
            setCookie(document.cookie);
        }
    }, 1000);
    const asJson = Object.fromEntries(cookie.split(`; `).map((i) => i?.split(`=`)));
    if (field) {
        return _.get(asJson, field, null);
    }
    if (options?.toJson) {
        return asJson;
    }
    return cookie;
};

export default useCookieChange;
